var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"loading":_vm.loading,"readonly":_vm.loading},on:{"change":_vm.switchBlockVisibility},model:{value:(_vm.WebAppVisible),callback:function ($$v) {_vm.WebAppVisible=$$v},expression:"WebAppVisible"}})}
var staticRenderFns = []

export { render, staticRenderFns }